import { useState } from 'react'

import { getDocFlowProfile } from '../../../api'
import { DocFlowRequestLinksField } from '../../../constants/docFlow'
import { TableServiceRequestCell } from '../../Table'

import {
  getDocFlowTableRowConnectedRequestsCellItems,
  isDocFlowTableRowConnectedRequestsDetailCurrent,
  isDocFlowTableRowConnectedRequestsListPartial,
} from './DocFlowTableRowConnectedRequestsCell.utils'

// The list row holds only the newest request and "+N" stays inert without
// dropdown items, so the detail's full list loads once the chips are entered.
function DocFlowTableRowConnectedRequestsCell({
  count,
  docFlowId,
  items,
  ...cellProps
}) {
  const [detail, setDetail] = useState(null)

  function handleLoadAllItems() {
    if (
      !isDocFlowTableRowConnectedRequestsDetailCurrent({ detail, items }) &&
      isDocFlowTableRowConnectedRequestsListPartial({ count, items })
    ) {
      setDetail({ items: null, sourceItems: items })

      getDocFlowProfile(docFlowId)
        .then(({ data }) => {
          setDetail({
            items: data[DocFlowRequestLinksField.DocFlowConnectedRequests],
            sourceItems: items,
          })
        })
        .catch(() => {
          setDetail(null)
        })
    }
  }

  return (
    <TableServiceRequestCell
      {...cellProps}
      items={getDocFlowTableRowConnectedRequestsCellItems({ detail, items })}
      listProps={{
        itemsCount: count,
        onFocus: handleLoadAllItems,
        onMouseEnter: handleLoadAllItems,
      }}
    />
  )
}

export default DocFlowTableRowConnectedRequestsCell
